import React, { FC, PropsWithChildren, useContext, useEffect } from 'react';
import AppContext from '../contexts/AppContext';

const MainApp: FC<PropsWithChildren>  = ({ children }) => {
  const { loadConfig } = useContext(AppContext);

  useEffect(() => {
    loadConfig();
  }, [loadConfig]);

  return (
    <>
      <div className='App'>{children}</div>
    </>
  );
};
export default MainApp;
